import React from 'react';
import { Zoom } from 'react-reveal';
import { Link } from 'react-router-dom';

const JobPreperationCart = ({ course }) => {
    const { courseThubnail, courseTitle, _id } = course;


    return (
        <div className='col-lg-3 col-md-4 col-sm-6 col-12'>
            <Zoom>
                <div className="shadow-lg text-center popularcart" style={{ minHeight: '250px', cursor: 'pointer' }} >
                    <img src={courseThubnail} alt={courseTitle} className='img-fluid mb-3 w-100' />
                    <h5 className='fw-bold fs-4'>{courseTitle}</h5>
                    <div className="jobBnt">
                        <Link to={`/jobPreperationDetails/${_id}`}>
                            <button className="btn text-primary fs-4">বিস্তারিত দেখুন</button>
                        </Link>
                    </div>
                </div>
            </Zoom>
        </div>
    );
};

export default JobPreperationCart;